"use client";

import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  quote: "Moondos Media transformed our digital presence. Their strategic approach to branding and content creation is why we're now leading our niche.",
  author: "Marcus Thorne",
  location: "Founder of Apex Digital"
}, {
  quote: "The team's ability to blend high-end aesthetics with technical performance is unmatched. Our new platform is a work of art that converts.",
  author: "Elena Rossi",
  location: "Creative Director"
}, {
  quote: "Working with Moondos was a game-changer for my personal brand. They understood my vision and scaled my reach across all platforms.",
  author: "David Vance",
  location: "Professional Athlete"
}];
export default function ClientAccolades() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}